import React, { useState } from 'react';
import { Tooltip, styled } from '@material-ui/core';

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} arrow />
))(({ theme }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: '#f7f7f8',
    color: '#000',
    padding: theme.spacing(2),
    boxShadow: `0px 0px 2px 0px ${theme.palette.primary.main}`,
  },
  [`& .MuiTooltip-arrow::before`]: {
    backgroundColor: '#f7f7f8',
    boxShadow: `0px 0px 2px 0px ${theme.palette.primary.main}`,
  },
}));

const EnergyTooltip = ({ title, children }) => {
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen((prev) => !prev);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <StyledTooltip
      title={title}
      open={open}
      onClose={handleClose}
      disableHoverListener
      disableFocusListener
      disableTouchListener
    >
      <div onClick={handleToggle} style={{ marginTop:"5px", display: 'inline-block', cursor: 'pointer' }}>
        {children}
      </div>
    </StyledTooltip>
  );
};

export default EnergyTooltip;